// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldPillInput_root__3F7is","inputRoot":"FieldPillInput_inputRoot__1qQCA","inputLabel":"FieldPillInput_inputLabel__3eHN0"};